export const roleRoutes = {
  UNITADMIN: '/employee',
  SUBUNITADMIN: '/employee',
  SUPERADMIN: '/dashboard',
  ADMIN: '/dashboard',
}

export const defaultRoute = '/masterdata'
